import { message as antdMessage } from "antd";
import React from "react";
import "./index.less";

// 自定义全局配置
const customConfig = {
  top: 40,
  className: "custom-ant-message",
  duration: 3,
  maxCount: 5
};

// 初始化全局配置
antdMessage.config(customConfig);

// 定义 AntdMessage 的参数类型
type MessageArgs =
  | React.ReactNode
  | {
      content: React.ReactNode;
      duration?: number;
      onClose?: () => void;
      key?: string | number;
      className?: string;
    };

// 包装 antdMessage，支持 key 和完整 API
const customMessage = {
  ...antdMessage, // 保留原有方法

  // 重写 success 方法，支持 key 和 className
  success: (args: MessageArgs, duration?: number, onClose?: () => void) => {
    // 处理两种调用方式：
    // 1. message.success(content, duration?, onClose?)
    // 2. message.success({ content, duration, onClose, key })
    const config =
      typeof args === "object" && !React.isValidElement(args)
        ? {
            ...args,
            className: `${customConfig.className} ${customConfig.className}-success`
          }
        : {
            content: args,
            duration,
            onClose,
            className: `${customConfig.className} ${customConfig.className}-success`
          };

    return antdMessage.success(config);
  },

  // 重写 error 方法，支持 key 和 className
  error: (args: MessageArgs, duration?: number, onClose?: () => void) => {
    const config =
      typeof args === "object" && !React.isValidElement(args)
        ? {
            ...args,
            className: `${customConfig.className} ${customConfig.className}-error`
          }
        : {
            content: args,
            duration,
            onClose,
            className: `${customConfig.className} ${customConfig.className}-error`
          };

    return antdMessage.error(config);
  },

  info: (args: MessageArgs, duration?: number, onClose?: () => void) => {
    const config =
      typeof args === "object" && !React.isValidElement(args)
        ? {
            ...args,
            className: `${customConfig.className} ${customConfig.className}-info`
          }
        : {
            content: args,
            duration,
            onClose,
            className: `${customConfig.className} ${customConfig.className}-info`
          };

    return antdMessage.info(config);
  },
  warning: (args: MessageArgs, duration?: number, onClose?: () => void) => {
    const config =
      typeof args === "object" && !React.isValidElement(args)
        ? {
            ...args,
            className: `${customConfig.className} ${customConfig.className}-warning`
          }
        : {
            content: args,
            duration,
            onClose,
            className: `${customConfig.className} ${customConfig.className}-warning`
          };

    return antdMessage.warning(config);
  },
  loading: (args: MessageArgs, duration?: number, onClose?: () => void) => {
    const config =
      typeof args === "object" && !React.isValidElement(args)
        ? {
            ...args,
            className: `${customConfig.className} ${customConfig.className}-loading`
          }
        : {
            content: args,
            duration,
            onClose,
            className: `${customConfig.className} ${customConfig.className}-loading`
          };

    return antdMessage.loading(config);
  }
};

export const message = customMessage;